<template>
    <div class="mt-1">
        <BRow>
            <BCol md="7" lg="7">
                <RequestInformation
                    :request="request"
                    :collapsed="requestInformationCollapsed"
                    @update:collapsed="setPreference('requestInformationCollapsed', $event)"
                />
            </BCol>
            <BCol md="5" lg="5">
                <ConversationV2
                    :request-id="request.id"
                    :title="conversationTitle"
                    :collapsed="conversationCollapsed"
                    @update:collapsed="setPreference('conversationCollapsed', $event)"
                />
            </BCol>
        </BRow>
    </div>
</template>

<script>
import { BCol, BRow } from 'bootstrap-vue'
import ConversationV2 from '@core/components/messenger/v2/ConversationV2.vue'
import { createUiPreferenceScope } from '@/store/ui-preferences'
import RequestInformation from './RequestInformation.vue'

export default {
    name: 'ManifestRequestOverview',
    components: {
        BCol,
        BRow,
        ConversationV2,
        RequestInformation,
    },
    props: {
        request: {
            type: Object,
            required: true,
        },
    },
    computed: {
        conversationTitle() {
            const key = 'Page(ReceivedRequest):Component(Overview):conversation-title'
            const translated = this.$t(key)

            return translated && translated !== key
                ? translated
                : 'Questions about this request?'
        },
        preferenceScope() {
            const subscriber = this.$store.getters.subscriber || {}
            const organization = this.$store.getters.organization || {}

            return createUiPreferenceScope({
                subscriberId: subscriber.id,
                organizationId: organization.id,
            })
        },
        requestInformationCollapsed() {
            return this.getPreference('requestInformationCollapsed')
        },
        conversationCollapsed() {
            return this.getPreference('conversationCollapsed')
        },
    },
    methods: {
        getPreference(key) {
            return this.$store.getters['uiPreferences/preference']({
                scopeKey: this.preferenceScope,
                group: 'receivedRequestOverview',
                key,
                fallback: false,
            })
        },
        setPreference(key, value) {
            return this.$store.dispatch('uiPreferences/setPreference', {
                scopeKey: this.preferenceScope,
                group: 'receivedRequestOverview',
                key,
                value,
            })
        },
    },
}
</script>
